import { useState, useEffect, useRef } from "react";
import { Header } from "../../components/Header";
import { Load } from "../../components/Load";
import { Sidebar } from "../../components/Sidebar";
import "./style.css";
import AlertMessage from "../../components/Alert";
import { CardContent } from "../../components/CardContent";
import { Main } from "../../components/Main";
import { Title } from "../../components/Title";
import { Row, Modal, Button, FormGroup, Col, Form } from "react-bootstrap";
import {
  Autocomplete,
  Box,
  LinearProgress,
  TextField,
  Typography,
} from "@mui/material";
import api from "../../services/api";
import { Label } from "reactstrap";
import { io } from "socket.io-client";
import PaidIcon from "@mui/icons-material/Paid";
import {
  Table,
  TBody,
  TCell,
  TGroup,
  ThCell,
  THeader,
  TRow,
} from "../../components/Table/Table";
import { useMediaQuery } from 'react-responsive';
import { display } from "html2canvas/dist/types/css/property-descriptors/display";
import jsPDF from 'jspdf';

const ReaproveitarAsos = () => {
  const [isLoading] = useState(false);
  const [alert, setAlert] = useState({
    show: false,
    message: "",
    variant: "success",
  });
  const [showAttachModal, setShowAttachModal] = useState(false);
  const [uploadFiles, setUploadFiles] = useState<any>([]);
  const uploadFilesRef = useRef<any>([]);
  console.log("🚀 ~ ReaproveitarAsos ~ uploadFilesRef:", uploadFilesRef)
  const [isDisabled, setIsDisabled] = useState(true);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [progressValue, setProgressValue] = useState(0);
  const [progressModalOpen, setProgressModalOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [examData, setExamData]: any = useState([]);
  const [funcoes, setFuncoes]: any = useState([]);
  const [funcoesSelecionadas, setFuncoesSelecionadas]: any = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [qrCode, setQrCode] = useState("");
  const [paymentApproved, setPaymentApproved] = useState(false);
  const [asosMapeados, setAsosMapeados]: any = useState([]);
  const [asosReaproveitados, setAsosReaproveitados]: any = useState([]);
  const [tempExames, setTempExames]: any = useState([])
  const [funcoesReaproveitamento, setFuncoesReaproveitamento] = useState<any>([]);
  const [selectedIndexAso, setSelectedIndexAso] = useState<number | null>(null);
  const [cupom, setCupom]: any = useState(null);
  const [preco, setPreco] = useState(50);
  const [descontoTotal, setDescontoTotal] = useState(false);
  const [cupomId, setCupomId] = useState();
  const [idTrabalhador, setIdTrabalhador] = useState();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [cuponsAtivos, setCuponsAtivos] = useState(false);
  const [redirectCounter, setRedirectCounter] = useState(3);
  const [user, setUser] = useState<any>();

  const handleUpdateWorker = async (exams: any, funcoesSelecionadas?: any) => {
    try {
      const body = { exams, funcoesSelecionadas };

      const existingReaproveitamentos = asosReaproveitados.filter((aso: any) =>
        exams.some((exam: any) => exam.exame === aso.exame)
      );

      if (existingReaproveitamentos.length > 0) {
        console.log("Reaproveitamento já existe para este trabalhador.");
        return;
      }

      const response = await api.post("salvar-reaproveitamento-trabalhador", body);
      const dados = await api.get(`listar-asos-assinados-por-trabalhador/${response.data.trabalhador}`);
      const reaproveitamentoAtualizado = response.data.reaproveitamentoTrabalhador;

      setAsosReaproveitados(dados.data.listaAsos.asosAssinados);
      setTempExames(dados.data.listaAsos.tempExames);
      setFuncoesReaproveitamento(dados.data.listaAsos.funcoes);
      setAsosMapeados(dados.data.listaAsos.asosReaproveitamento);
      setExamData([]);
      setFuncoes([]);
      setFuncoesSelecionadas([]);
      setSelectedFileName("");

      return reaproveitamentoAtualizado;
    } catch (error) {
      console.error("Erro ao atualizar trabalhador:", error);
    }
  };


  const handleSavePayment = async (paymentData: any) => {
    if (paymentData) {
      await api.post('salvar-pagamento-reaproveitamento-trabalhador', paymentData)
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: user } = await api.get("dados-usuario");
        setUser(user);
        const res = await api.get(`buscar-trabalhador-por-user/${user.id}`);
        if (res.status === 200) {
          setIdTrabalhador(res.data);
          const response = await api.get(`listar-asos-assinados-por-trabalhador/${res.data}`);
          setAsosReaproveitados(response.data.listaAsos.asosAssinados);
          setTempExames(response.data.listaAsos.tempExames)
          setFuncoesReaproveitamento(response.data.listaAsos.funcoes);
          setAsosMapeados(response.data.listaAsos.asosReaproveitamento);
        }
        const cupons = await api.get('listar-cupons');
        if (Array.isArray(cupons.data) && cupons.data.length > 0) {
          const cuponsAtivos = cupons.data.filter((cupom: any) => !cupom.desativado);
          if (cuponsAtivos.length > 0) setCuponsAtivos(true);
        }
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };

    fetchData();
  }, []);

  // useEffect(() => {
  //   if (asosReaproveitados.length > 0) {
  //     const uniqueAsos = Array.from(new Map(asosReaproveitados.map((item: any) => [item.index_aso, item])).values());
  //     const uniqueAsosSorted = uniqueAsos.sort((a: any, b: any) => a.index_aso - b.index_aso);
  //     setAsosMapeados(uniqueAsosSorted);
  //   }
  // }, [asosReaproveitados]);

  const handleFileSelection = async (e: any) => {
    const file = e.target.files[0];
    if (file) {
      const fileName = file.name.concat(`- ${formatDateToStandard(new Date())}`);
      let processedFile = file;

      if (file.type.startsWith("image/")) {
        const imageData = await readFileAsDataURL(file);
        const imgType = file.type === "image/png" ? "PNG" : "JPEG";

        const doc = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: "a4",
        });

        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        const img = new Image();
        img.src = imageData;

        img.onload = () => {
          let imgWidth = img.width;
          let imgHeight = img.height;

          if (imgWidth > imgHeight) {
            const ratio = imgHeight / imgWidth;
            imgWidth = pageWidth;
            imgHeight = pageWidth * ratio;
          } else {
            const ratio = imgWidth / imgHeight;
            imgHeight = pageHeight;
            imgWidth = pageHeight * ratio;
          }

          const x = (pageWidth - imgWidth) / 2;
          const y = (pageHeight - imgHeight) / 2;
          doc.addImage(imageData, imgType, x, y, imgWidth, imgHeight);
          const pdfBlob = doc.output("blob");
          processedFile = new File(
            [pdfBlob],
            fileName.replace(/\.[^/.]+$/, ".pdf"),
            { type: "application/pdf" }
          );
          addFileToUploadList(processedFile);
        };
      } else {
        addFileToUploadList(file);
      }
      setSelectedFileName(fileName);
      if (isDisabled) setIsDisabled(false);
    }
  };

  const addFileToUploadList = (file: File) => {
    setUploadFiles((prevFiles: any) => {
      const updatedFiles = [...prevFiles, file];
      uploadFilesRef.current = updatedFiles;
      return updatedFiles;
    });
  };

  const readFileAsDataURL = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const simulateProgress = () => {
    let progress = 0;
    const interval = setInterval(() => {
      if (progress < 95) {
        progress += 13.0;
        setProgressValue(progress);
      } else {
        clearInterval(interval);
      }
    }, 800);
  };

  function readFileAsBytes(file: File): Promise<number[]> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        if (event.target?.result) {
          const arrayBuffer = event.target.result as ArrayBuffer;
          const uint8Array = new Uint8Array(arrayBuffer);
          const bytes = Array.from(uint8Array);
          resolve(bytes); // Resolva a Promise com os bytes
        } else {
          reject(new Error('Erro ao ler o arquivo.'));
        }
      };

      reader.onerror = (error) => {
        reject(error); // Rejeite a Promise em caso de erro
      };

      reader.readAsArrayBuffer(file); // Inicia a leitura do arquivo
    });
  }

  const handleFileUpload = async () => {
    try {
      // 1. Criar um novo FormData para todos os arquivos
      const formData = new FormData();
      const formattedDate = formatDateToStandard(new Date());

      // 2. Adicionar todos os arquivos ao FormData
      for (const file of uploadFilesRef.current) { // Usa os arquivos da referência
        const fileName = file.name.replace(/\.pdf$/i, `-${formattedDate}.pdf`);
        formData.append("files[]", file, fileName);
      }

      setProgressValue(0);
      simulateProgress();
      setShowAttachModal(false);
      setProgressModalOpen(true);

      // 3. Enviar todos os arquivos em uma única requisição
      const response = await api.post("/reaproveitar-aso/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const responseData = response.data;
      let newExams: any;
      if (Array.isArray(responseData.exame)) {
        newExams = responseData.exame.map((exame: any) => ({
          exame,
          data: responseData.data,
          tipo_exame: responseData.tipo_exame,
          normas: responseData.normas,
        }));
      }
      setExamData(newExams);


      let funcoes;
      if (responseData.funcao) {
        const funcaoEncontrada = await api.get(`funcionarios/buscar-funcao/${responseData.funcao.nome}`);
        const { id, nome } = funcaoEncontrada.data[0];
        setFuncoesSelecionadas([{ id, nome }]);
        funcoes = [{ id, nome }];
      }

      // 4. Atualizar o trabalhador com os novos exames e funções
      const novoReaproveitamento = await handleUpdateWorker(newExams, funcoes);
      const data = { id: novoReaproveitamento, nomeDoPdf: `${formattedDate}.pdf` };

      // Converte os arquivos para Base64
      const base64Files = await Promise.all(
        uploadFilesRef.current.map(async (file: File) => {
          const base64 = await readFileAsBase64(file);
          return {
            bytes: base64,
            fileName: file.name.replace(/\.pdf$/i, `-${formattedDate}.pdf`),
          };
        })
      );

      const payload = {
        bytes: base64Files.map((file) => file.bytes),
        data: {
          nomeDoPdf: `${formattedDate}.pdf`,
          id: novoReaproveitamento,
        },
      };

      const uploadExameResponse = await api.post('/upload-reaproveitamento-exame', payload);

      if (uploadExameResponse.status === 200) {
        setProgressValue(100);
        setProgressModalOpen(false);
        setAlert({
          show: true,
          message: "Arquivos enviados com sucesso!",
          variant: "success",
        });
        setUploadFiles([]);
        uploadFilesRef.current = [];
      }
    } catch (error) {
      setProgressValue(100);
      setProgressModalOpen(false);
      setAlert({
        show: true,
        message: "Erro ao enviar os arquivos.",
        variant: "danger",
      });
    }
  };

  const readFileAsBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve((reader.result as string).split(",")[1]);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const handleListFunction = async (inputValue: any) => {
    if (inputValue.length > 3) {
      const response = await api.get(
        `funcionarios/buscar-funcao/${inputValue}`
      );
      const responseData = response.data;
      setFuncoes(responseData);
    } else {
      setFuncoes([]);
    }
  };

  const handlePayment = async () => {
    try {

      if (descontoTotal) {
        handleFileUpload();
      } else {
        const paymentDetails = {
          transaction_value: preco,
          description: "Pagamento de Reaproveitamento de ASO",
          email: "comercial@medicoatento.com.br",  // #TODO: Alterar para gerar pagamento
          cpf: "xxx.xxx.xxx-xx",
        };
        const response = await api.post("/pix/create", paymentDetails);
        setQrCode(response.data.qr_code_base64);
        setShow(true);
      }
    } catch (error) {
      console.error("Erro ao criar pagamento PIX:", error);
    }
  };

  const transformarPreco = (valor: any) => {
    const valorCorrigido = valor / 100 / 2;
    return valorCorrigido.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  const formatDateToStandard = (date: any) => {
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  const formatDate = (dateString: any) => {
    // Função para verificar se a data está no formato dd/mm/yyyy
    const isValidDateFormat = (dateStr: any) => {
      const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
      return regex.test(dateStr);
    };

    // Função para formatar a data no formato dd/mm/yyyy às HHhMM
    const formatToDateTime = (date: any) => {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      const hours = (date.getHours()).toString().padStart(2, "0"); // Ajuste de fuso horário
      const minutes = date.getMinutes().toString().padStart(2, "0");

      return `${day}/${month}/${year}`;
    };

    // Verifica se a data está no formato dd/mm/yyyy
    if (isValidDateFormat(dateString)) {
      const [day, month, year] = dateString.split("/");
      const date = new Date(`${year}-${month}-${day}`);
      return formatToDateTime(date);
    }
    const date = new Date(dateString);
    return formatToDateTime(date);
  };

  const getNomeByIndexAso = (index: number) => {
    const item = funcoesReaproveitamento.filter((n: any) => n.index_aso === index);
    if (item) return item.nomes;
  };

  const handleSearchCupom = async () => {
    try {
      const response = await api.post(`buscar-cupom-por-nome/${cupom}`);
      if (response.status === 200 && response.data) {
        if (response.data.cupom && response.data.cupom.desconto) {
          const { desconto, id: cupomId } = response.data.cupom;
          setCupomId(cupomId);
          if (preco) {
            const novoPreco: any = calcularNovoPreco(preco, desconto);
            if (novoPreco === 0) setDescontoTotal(true);
            setPreco(novoPreco);
          }
          await api.post(`cupons/desativar/${cupomId}`);
          setAlert({ show: true, message: response.data.message, variant: 'success' });
        }
      } else {
        setAlert({ show: true, message: response.data.message || 'Cupom inválido ou expirado.', variant: 'danger' });
      }
    } catch (error: any) {
      if (error.response && error.response.data && error.response.data.message) {
        setAlert({ show: true, message: error.response.data.message, variant: 'danger' });
      } else {
        setAlert({ show: true, message: 'Erro ao buscar o cupom.', variant: 'danger' });
      }
      console.log(error);
    }
  }

  const calcularNovoPreco = (preco: number, desconto: number): number => {
    const novoPreco = (preco * (1 - desconto / 100));
    return novoPreco < 0 ? 0 : novoPreco;
  };
  const combinedData = [
    ...asosReaproveitados
      .filter((item: any) => item.index_aso === selectedIndexAso)
      .map((reaproveitamento: any) => ({
        type: 'ASO',
        nome: reaproveitamento.ateBaseExames.nome,
        data: reaproveitamento.data_realizacao
      })),
    ...tempExames
      .filter((exam: any) => exam.index_aso === selectedIndexAso)
      .map((tempExame: any) => ({
        type: 'Exame',
        nome: tempExame.nome,
        data: tempExame.data_realizacao
      }))
  ];

  useEffect(() => {
    const socket = io(`https://apihomol.meupgr.com.br`, { transports: ['websocket', 'polling'] });

    socket.on('paymentStatusUpdated', async (data: any) => {
      console.log("🚀 ~ socket.on ~ data:", data)
      if (data.status === 'approved') {
        setShow(false);
        await handleFileUpload();
        await handleSavePayment(data);
      }
    });

    return () => {
      socket.off('paymentStatusUpdated');
    };
  }, []);

  useEffect(() => {
    if (paymentApproved) {
      const progressTimer = setInterval(() => {
        setProgressValue((oldValue) => {
          const newValue = oldValue + 1;
          if (newValue === 100) {
            clearInterval(progressTimer);
            const redirectTimer = setInterval(() => {
              setRedirectCounter((counter) => {
                if (counter === 1) {
                  clearInterval(redirectTimer);
                  handleUpdateWorker(examData);
                }
                return counter - 1;
              });
            }, 1000);
          }
          return newValue;
        });
      }, 100);
    }
  }, [paymentApproved]);

  return (
    <>
      <Load isLoading={isLoading} />
      <Sidebar />
      <Header route="./" />
      <Main>
        <CardContent style={{ width: "50% !important" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Row>
              <Title text="Reaproveitar Asos" />
            </Row>
            {/* <Row style={{ marginTop: "20px", textAlign: "center" }}>
              <h6>Exames</h6>
              {examData.map((exam: any, index: any) => (
                <p key={index} style={{ fontSize: "14px", margin: "10px" }}>
                  {exam.exame} -{" "}
                  {exam.normas[1]
                    ? "(" + exam.normas[0] + " / " + exam.normas[1] + ")"
                    : "(" + exam.normas[0] + ")"}{" "}
                  - {exam.tipo_exame} - {exam.data}
                </p>
              ))}
            </Row>
            <Row style={{ marginTop: "20px" }}>
              <Button
                style={{
                  backgroundColor: "#02298A",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => setShowAttachModal(true)}
              >
                Anexar Exames PDF
              </Button>
            </Row> */}
            <Row style={{ marginTop: '20px' }}>
              {/* Input para capturar foto */}
              <input
                type="file"
                id="photoInput"
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleFileSelection}
              />

              {/* Input para selecionar PDF */}
              <input
                type="file"
                id="pdfInput"
                accept=".pdf"
                style={{ display: "none" }}
                onChange={handleFileSelection}
              />

              {/* Botões de seleção */}
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                <label
                  htmlFor="photoInput"
                  style={{
                    border: "2px solid #0d6efd",
                    padding: "20px",
                    width: "48%",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    cursor: "pointer",
                    color: "#0d6efd",
                    borderRadius: "4px",
                  }}
                >
                  Selecionar Foto
                </label>

                <label
                  htmlFor="pdfInput"
                  style={{
                    border: "2px dashed #0d6efd",
                    padding: "20px",
                    width: "48%",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    cursor: "pointer",
                    color: "#0d6efd",
                    borderRadius: "4px",
                  }}
                >
                  Inserir PDF
                </label>
              </div>

              {/* Container para exibir arquivos selecionados */}
              <div className="file-upload-container">
                {uploadFiles.length > 0 && uploadFiles.map((file: any, index: number) => {
                  const fileName = file.name + ' - ' + formatDateToStandard(new Date());
                  return (
                    <div key={index} className="file-upload-item">
                      <div className="file-upload-name">
                        <span>{fileName}</span>
                      </div>
                      <div>
                        <button
                          className="file-upload-button"
                          onClick={() => setUploadFiles(uploadFiles.filter((f: any, i: number) => i !== index))}
                        >
                          Remover
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Row>
            {/* <Row style={{ marginTop: "20px" }}>
              <h6>Suas Funções</h6>
            </Row>
            <Row className='row-functions'>
              <FormGroup className="form-group-dsg">
                <Label title="Nome (DIGITE E SELECIONE)" htmlFor="inf" />
                <Autocomplete
                  multiple
                  value={funcoesSelecionadas}
                  className='autocomplete'
                  onChange={(event, newValue) => {
                    setFuncoesSelecionadas(newValue);
                  }}
                  onInputChange={(event, newInputValue) => {
                    handleListFunction(newInputValue);
                  }}
                  noOptionsText="Digite e selecione"
                  getOptionLabel={(option) => (option ? option.nome : "")}
                  renderInput={(params) => <TextField {...params} label="" />}
                  options={funcoes}
                />
              </FormGroup>
            </Row> */}
            <Row style={{ marginTop: "70px" }}>
              <Button
                style={{
                  backgroundColor: "#02298A",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={handlePayment}
                disabled={isDisabled}
              >
                Reaproveitar
              </Button>
            </Row>
          </div>
        </CardContent>
        <CardContent>
          <Title text="ASOS Reaproveitados" />
          <Row>
            <Col>
              <Table>
                <THeader>
                  <ThCell>ASO Reaproveitado</ThCell>
                  <ThCell>Data do Reaproveitamento</ThCell>
                  <ThCell>Funções</ThCell>
                  <ThCell>Exames</ThCell>
                </THeader>
                <TBody>
                  <TGroup>
                    {asosMapeados.length > 0 ? (
                      <>
                        {asosMapeados.map(
                          (reaproveitamento: any, index: number) => {
                            // const funcaoEncontrada = getNomeByIndexAso(reaproveitamento.index_aso);
                            return (
                              <TRow key={index}>
                                <TCell>
                                  Reaproveitamento {reaproveitamento.index_aso || ''}
                                </TCell>
                                <TCell>
                                  {formatDate(reaproveitamento.created_at)}
                                </TCell>
                                <TCell>
                                  {reaproveitamento.funcoes !== '' ? reaproveitamento.funcoes : 'Nenhuma função encontrada'}
                                </TCell>
                                <TCell>
                                  <TCell>
                                    {reaproveitamento.exames.length > 0 ? (

                                      <Button
                                        onClick={() => {
                                          setSelectedIndexAso(
                                            reaproveitamento.index_aso
                                          );
                                          setShowModal(true);
                                        }}
                                      >
                                        Visualizar Exames
                                      </Button>
                                    ) : (
                                      <p>Nenhum exame encontrado</p>
                                    )}
                                  </TCell>
                                </TCell>
                              </TRow>
                            );
                          }
                        )}
                      </>
                    ) : (
                      <>
                        <TRow className="center-text-not-found">
                          <p>Nenhum reaproveitamento de ASO encontrado</p>
                        </TRow>
                      </>
                    )}
                  </TGroup>
                </TBody>
              </Table>
            </Col>
          </Row>
        </CardContent>
        {cuponsAtivos && (
          <div style={{ marginTop: '10px', marginBottom: '10px' }}>
            <h6>Se você possui um cupom de desconto, insira-o aqui para aproveitar o desconto!</h6>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '10px' }}>
              <input
                type="text"
                id="nome"
                placeholder="Digite o Código"
                value={cupom}
                onChange={(e) => setCupom(e.target.value.toUpperCase())}
                style={{ width: '145px', height: '50px', border: '1px solid lightgray', borderRadius: '3px', fontSize: '13px', padding: '10px' }}
              />
              <Button
                style={{ backgroundColor: '#02298A', color: 'white', border: 'none', borderRadius: '5px', height: '40px' }}
                onClick={handleSearchCupom}
              >
                Aplicar
              </Button>
            </div>
          </div>
        )}
      </Main>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Confirmação de Pagamento</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            margin: "auto",
          }}
        >
          {paymentApproved ? (
            <div style={{ textAlign: "center" }}>
              <PaidIcon sx={{ color: "green !important", fontSize: "70px" }} />
              <p style={{ fontSize: "20px", color: "green" }}>
                Seu pagamento foi aprovado com sucesso!
              </p>
              <p>
                Os exames estão disponíveis para reutilização. Um e-mail com o
                link de compartilhamento foi enviado para você, para que possa
                enviá-lo à empresa de sua escolha.
              </p>
              <p>
                Obrigado pela confiança na{" "}
                <b>Atento Medicina de Trabalho LTDA.</b>
              </p>
            </div>
          ) : (
            <>
              {" "}
              <div style={{ textAlign: "center" }}>
                <p style={{ fontSize: "20px" }}>
                  Beneficiário: <b>{user?.nome}</b>
                  <br />
                  Valor: <b>R$ {preco}</b>
                </p>
              </div>
              {qrCode ? (
                <img
                  src={`data:image/png;base64,${qrCode}`}
                  className="qrCode"
                  alt="QR Code"
                />
              ) : (
                <p>Carregando QR Code...</p>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        ></Modal.Footer>
      </Modal>

      <AlertMessage
        show={alert.show}
        message={alert.message}
        variant={alert.variant}
        onClose={() => setAlert({ ...alert, show: false })}
      />

      <Modal
        show={progressModalOpen}
        sx={{ display: "grid", placeItems: "center" }}
        disableEscapeKeyDown={true}
      >
        <Box
          sx={{
            width: "500px",
            p: 3,
            bgcolor: "background.paper",
            borderRadius: "5px",
          }}
        >
          <Typography sx={{ textAlign: "center", paddingBottom: "10px" }}>
            Aguarde, importando documento.
          </Typography>
          <LinearProgress
            variant="determinate"
            value={progressValue}
            sx={{ height: "5px", borderRadius: "3px" }}
          />
        </Box>
      </Modal>

      <Modal size="xl" show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <b>Exames Incluídos</b>
        </Modal.Header>
        <Modal.Body>
          <Table>
            <THeader className="table-row-funcao">
              <ThCell>Exame</ThCell>
              <ThCell>Data de Realização</ThCell>
            </THeader>
            <TBody>
              <TGroup>
                {combinedData.map((item: any, index: number) => (
                  <TRow className="table-row-funcao" key={index}>
                    <TCell>{item.nome}</TCell>
                    <TCell>{formatDate(item.data)}</TCell> {/* Formata a data */}
                  </TRow>
                ))}
              </TGroup>
            </TBody>
          </Table>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ReaproveitarAsos;
